import { htmlToText } from "Utils";
import {
  TABLE_QUESTION_SETTINGS,
  TABLE_INPUT_END_CHAR,
  TABLE_INPUT_START_CHAR,
} from "./constants";
import _ from "lodash";
import { getIsWorksheetDocEditorEnabled } from "Worksheet/modules/WorksheetFeatureFlags";
import {
  removeEmptyLines,
  extractTextWithLatex,
} from "Worksheet/modules/WorksheetUtils";

export const getTableSettingsOptions = ({ t }) => {
  const options = [];
  _.forEach(TABLE_QUESTION_SETTINGS, option => {
    options.push({
      ...option,
      label: t(option.label),
    });
  });
  return options;
};

// This function gives paramters of cell, cell params define cell's view and functions.
export const getDraggableCellParams = ({
  mode = "create",
  isHeader = false,
  cell,
}) => {
  const showDocEditor = getIsWorksheetDocEditorEnabled();
  let cellVal = _.isEqual(mode, "create")
    ? cell.getValue()
    : htmlToText(cell.getValue());
  if (showDocEditor) {
    cellVal = extractTextWithLatex(cell.getValue());
  }
  let originalCellVal = removeEmptyLines(cell.getValue());

  const modeCheck = !_.includes(["preview", "create"], mode);
  const isAnswerVariable =
    _.startsWith(cellVal, TABLE_INPUT_START_CHAR) &&
    _.endsWith(cellVal, TABLE_INPUT_END_CHAR);

  let isInputCell = false;
  if (isAnswerVariable && modeCheck) {
    isInputCell = true;
    cellVal = cellVal.substring(1, cellVal.length - 1);

    // For answer variable "{}"
    if (
      _.startsWith(originalCellVal, TABLE_INPUT_START_CHAR) &&
      _.endsWith(originalCellVal, TABLE_INPUT_END_CHAR)
    ) {
      originalCellVal = originalCellVal.substring(
        1,
        _.size(originalCellVal) - 1
      );
    }
  }

  // If the cell is empty and the mode is neither create nor preview then allow editing
  if (_.isEmpty(cellVal) && modeCheck) {
    isInputCell = true;
  }

  // Extract the answer block without the input start end characters
  if (
    _.includes(["evaluate", "view"], mode) &&
    showDocEditor &&
    isAnswerVariable
  ) {
    originalCellVal = originalCellVal.replace(
      new RegExp(
        `\\${TABLE_INPUT_START_CHAR}([^\\${TABLE_INPUT_END_CHAR}]*)\\${TABLE_INPUT_END_CHAR}`,
        "g"
      ),
      "$1"
    );
  }

  let isDisabled = false;
  let showDisabledCell = false;

  switch (mode) {
    case "evaluate":
    case "view":
    case "preview":
    case "restricted-view":
      isDisabled = true;
      if (!isInputCell) {
        showDisabledCell = true;
      }
      break;
    case "edit":
    case "teacher-preview":
      if (cellVal && !isInputCell) {
        isDisabled = true;
        showDisabledCell = true;
      }
      if (isHeader) {
        isDisabled = true;
      }
      break;
  }

  return {
    isInputCell,
    cellVal: showDocEditor ? originalCellVal : cellVal,
    isDisabled,
    showDisabledCell,
    isAnswerVariable,
  };
};

const getFixedRowsAndColumns = ({ rows, columns }) => {
  return _.filter([...columns, ...rows], item => _.get(item, "isFixed"));
};

export const getFixedRowsAndColumnsMemoized = _.memoize(
  params => getFixedRowsAndColumns(params),
  ({ rows, columns }) => {
    const fixedRowIds = _.map(_.filter(rows, "isFixed"), "id");
    const fixedColumnIds = _.map(_.filter(columns, "isFixed"), "id");

    const rowsKey = _.join(fixedRowIds, "|");
    const columnsKey = _.join(fixedColumnIds, "|");

    return `rows:${rowsKey}~cols:${columnsKey}`;
  }
);
